module.exports = __webpack_public_path__ + "static/media/background.71c0f14b.svg";